/**
 * ページごとのSNSボタン、シェアリンクの設定
 */
export default class Share {
  /**
   * コンストラクタ
   */
  constructor(el) {
    // クラス名
    this.name = 'Share';
    //this.elID = 'js-snsShare';
    this.el = el;
    this.default = {
      hashtag: ''
    };

    this.init();
  }

  /**
   * 初期化
   */
  init() {
    //this.el = document.getElementById(this.elID);
    if (!this.el) return;

    this.meta = this.getMeta();

    /** twitter */
    const btnTwitter = this.el.querySelector('.btn-twitter');
    if (btnTwitter) {
      btnTwitter.setAttribute('href', 'https://twitter.com/intent/tweet?text=' + encodeURIComponent(`${this.meta.title} ${this.meta.url} ${this.meta.hashtag}`));
      btnTwitter.setAttribute('target', '_blank');
    }

    /** facebook */
    const btnFacebook = this.el.querySelector('.btn-facebook');
    if (btnFacebook) {
      btnFacebook.setAttribute('href', 'http://www.facebook.com/share.php?u=' + this.meta.url);
      btnFacebook.setAttribute('target', '_blank');
    }
  }

  /**
   * ページに設定されているメタタグを取得する
   */
  getMeta() {
    const ogTitle = document.querySelector("meta[property='og:title']");
    const ogDescription = document.querySelector("meta[property='og:description']");
    const ogUrl = document.querySelector("meta[property='og:url']");

    return {
      title: ogTitle ? ogTitle.getAttribute('content') : '',
      description: ogDescription ? ogDescription.getAttribute('content') : '',
      url: ogUrl ? ogUrl.getAttribute('content') : '',
      hashtag: this.default.hashtag
    }
  }
}